import React, { useState, useRef, useCallback, Fragment, useContext } from 'react'//,{useState,useCallback}
import styles from './ChannelSettings.module.css'
import Flatpickr from "react-flatpickr";
import { DropdownButton, Dropdown, Button } from 'react-bootstrap'
import SettingsDropDown from '../../../UI/SettingsDropDown/SettingsDropDown'
import { useTranslation } from "react-i18next";
import { replaceAll } from '../../../../util/functions'
import AlertContext from '../../../../context/AlertModelContext/AlertModalContext'
import SettingsTextBox from '../../../UI/SettingsTextBox/SettingsTextBox'
// import useInput from '../../../../hooks/use-input'
// import {useTranslation} from "react-i18next";

const getErrorMsg = (settingName, value) => {
    switch (settingName) {
        case 'closeInquiriesAfterHours':
            if (!Number.isInteger(Number(value)) || value < 0) return 'auto close inquiry must be integer';
            break;
        case 'sendMsgToOpenInqNoResFromClientAfterHours':
            if (!Number.isInteger(Number(value)) || value < 0) return 'Send Msg Before Close Inquire';
            break;
        default:
            return undefined;
    }
};
const ChannelSettings = (props) => {
    //translations
    // const [t, i18n] = useTranslation('common');

    //useState
    const [selectedTempMsgState, setSelectedTempMsgState] = useState()
    const [nowSelectedMsgTextState, setNowSelectedMsgTextState] = useState('')
    const [autoMsgStartTimePickedState, setAutoMsgStartTimePickedState] = useState()
    const [autoMsgEndTimePickedState, setAutoMsgEndTimePickedState] = useState()
    const [startDayInputState, setStartDayInputState] = useState()
    const [endDayInputState, setendDayInputState] = useState()
    const [displaySelectedTempMsgState, setDisplaySelectedTempMsgState] = useState(false)
    const [t] = useTranslation('common')
    const autoMsgStartRef = useRef()
    const autoMsgEndRef = useRef()
    const alertCtx = useContext(AlertContext)

    const [activeStartDay, setActiveStartDay] = useState(props.botSettings.activeStartDay || '');
    const [activeEndDay, setActiveEndDay] = useState(props.botSettings.activeEndDay || '');
    const [activeStartTime, setActiveStartTime] = useState(props.botSettings.activeStartTime || null);
    const [activeEndTime, setActiveEndTime] = useState(props.botSettings.activeEndTime || null);
    const [showBotActiveTime, setShowBotActiveTime] = useState(false);

    // const {
    //     value: autoCloseInValue,
    //     isValid: isAutoCloseInValid,
    //     resetInput: resetAutoCloseInInput,
    //     inputChangedHandler: inputAutoCloseInChangedHandler,
    // } = useInput((value) => Number.isInteger(value))

    const onAutoSendTempMsgDeleteClicked = props.onAutoSendTempMsgDeleteClicked
    const onAutoSendTempMsgUpdateClicked = props.onAutoSendTempMsgUpdateClicked
    const onTempMsgAdd = props.onTempMsgAdd
    const onTempMsgDelete = props.onTempMsgDelete
    const setSettings = props.setsettings
    const setSaveAndRestartBtnActiveState = props.setSaveAndRestartBtnActiveState
    // const onSaveClicked = props.onSaveClicked

    const handleOnClearTempMsgData = useCallback(() => {
        setAutoMsgStartTimePickedState()
        setAutoMsgEndTimePickedState()
        setStartDayInputState('')
        setendDayInputState('')
        setSelectedTempMsgState(undefined);
        setNowSelectedMsgTextState('');
        setDisplaySelectedTempMsgState(false)
    }, [])
    const onCancelNotifyClicked = useCallback((selectedTempMsgState) => {
        handleOnClearTempMsgData()
        onAutoSendTempMsgDeleteClicked(selectedTempMsgState)
        alertCtx.showAlert(t('success'), t('The time for the automatic message has been canceled'), 'sm')
    }, [onAutoSendTempMsgDeleteClicked, handleOnClearTempMsgData, alertCtx])
    const setSettingsMiddleware = useCallback((settingType, settingName, value) => {
        const errorMsg = getErrorMsg(settingName, value)
        if (errorMsg) return alertCtx.showAlert(t('fail'), t(errorMsg), 'sm')

        setSettings(settingType, settingName, value)
        setSaveAndRestartBtnActiveState(true)
    }, [setSettings, setSaveAndRestartBtnActiveState, alertCtx, t])
    const saveTempMsg = useCallback(() => {
        if (selectedTempMsgState) {//update msg
            if ((autoMsgStartTimePickedState || autoMsgEndTimePickedState || startDayInputState !== '' || endDayInputState !== '') &&
                (!autoMsgStartTimePickedState || !autoMsgEndTimePickedState || startDayInputState === '' || endDayInputState === '')) {
                // return alert('נא למלא את כל השדות')
                return alertCtx.showAlert(t('fail'), t('Please fill in all the fields'), 'sm')
            }
            // console.log(selectedTempMsgState)
            // console.log(nowSelectedMsgTextState)
            let updatedTempMsg = JSON.stringify(selectedTempMsgState)
            updatedTempMsg = JSON.parse(updatedTempMsg)
            updatedTempMsg.msg = nowSelectedMsgTextState

            onAutoSendTempMsgUpdateClicked(updatedTempMsg, autoMsgStartTimePickedState, autoMsgEndTimePickedState, startDayInputState, endDayInputState, displaySelectedTempMsgState)
            handleOnClearTempMsgData()
            alertCtx.showAlert(t('success'), t('successfuly updated'), 'sm')
            // alert(t('successfuly updated'))
        }
        else {//add new msg
            if (nowSelectedMsgTextState.length > 0) {
                onTempMsgAdd(nowSelectedMsgTextState, displaySelectedTempMsgState)
                handleOnClearTempMsgData()
                alertCtx.showAlert(t('success'), t('successfuly updated'), 'sm')
                // alert(t('successfuly updated'))
            }
        }
    }, [t, handleOnClearTempMsgData, alertCtx, onTempMsgAdd, nowSelectedMsgTextState, selectedTempMsgState, onAutoSendTempMsgUpdateClicked, autoMsgStartTimePickedState, autoMsgEndTimePickedState, startDayInputState, endDayInputState, displaySelectedTempMsgState])
    const deleteTempMsg = useCallback(() => {
        if (!selectedTempMsgState) return alertCtx.showAlert(t('fail'), t('Please select a message'), 'sm') //return alert('please select msg')
        onTempMsgDelete(selectedTempMsgState._id)
        handleOnClearTempMsgData()
        alertCtx.showAlert(t('success'), t('successfuly updated'), 'sm')
        // alert(t('successfuly updated'))
    }, [t, alertCtx, onTempMsgDelete, selectedTempMsgState, handleOnClearTempMsgData])
    const onAcceptNotifyClicked = useCallback(() => {
        onAutoSendTempMsgUpdateClicked(selectedTempMsgState, autoMsgStartTimePickedState, autoMsgEndTimePickedState, startDayInputState, endDayInputState, displaySelectedTempMsgState)
        // alert(t('successfuly updated'))
        alertCtx.showAlert(t('success'), t('successfuly updated'), 'sm')
        // onSaveClicked()
    }, [t, alertCtx, onAutoSendTempMsgUpdateClicked, selectedTempMsgState, autoMsgStartTimePickedState, autoMsgEndTimePickedState, startDayInputState, endDayInputState, displaySelectedTempMsgState])

    const handleOnStartDayInputChange = useCallback((event) => {//event.target.value
        const newValue = replaceAll(event.target.value, /[^\d]/, '')
        if ((newValue.length === 1 && (parseInt(newValue) > 0) && parseInt(newValue) < 8) || newValue.length === 0) {
            setStartDayInputState(newValue)
        }
    }, [setStartDayInputState])

    const handleOnEndDayInputChange = useCallback((event) => {//event.target.value
        const newValue = replaceAll(event.target.value, /[^\d]/, '')
        if ((newValue.length === 1 && (parseInt(newValue) > 0) && parseInt(newValue) < 8) || newValue.length === 0) {
            setendDayInputState(newValue)
        }
    }, [setendDayInputState])

    //Inquiries settings
    const channelSettings = props.channelsettings
    const botSettings = props.botSettings
    const generalSettings = props.generalSettings


    //template time control
    let allTempMsgAtt = []
    // console.log(allTempMsgAtt)

    if (props.tempmsgs && props.tempmsgs !== []) {
        console.log(props.tempmsgs)
        allTempMsgAtt = props.tempmsgs.filter(tempMsg => !tempMsg.whatsappVerified).map(tempMsg => {
            return <Dropdown.Item key={tempMsg._id}
                onClick={() => {
                    setAutoMsgStartTimePickedState(tempMsg.autoSendStartTime);
                    setAutoMsgEndTimePickedState(tempMsg.autoSendEndTime);
                    setStartDayInputState(tempMsg.autoSendStartDay ? tempMsg.autoSendStartDay : '');
                    setendDayInputState(tempMsg.autoSendEndDay ? tempMsg.autoSendEndDay : '');
                    setSelectedTempMsgState(tempMsg);
                    setNowSelectedMsgTextState(tempMsg.msg);
                    setDisplaySelectedTempMsgState(tempMsg.display)
                }}
                className={styles.specificSettingsDropDownItemTempMsg}>
                {tempMsg.msg}
            </Dropdown.Item>
        })
    }

    allTempMsgAtt = [
        <Dropdown.Item key={'newTempLateMsg'}
            onClick={() => {
                setAutoMsgStartTimePickedState(undefined);
                setAutoMsgEndTimePickedState(undefined);
                setStartDayInputState(undefined);
                setendDayInputState(undefined);
                setSelectedTempMsgState(undefined);
                setNowSelectedMsgTextState('');
                setDisplaySelectedTempMsgState(false);
            }}
            className={styles.specificSettingsDropDownItemTempMsg}>{t('Create a new message')}</Dropdown.Item>
        , ...allTempMsgAtt]

    //DropDowns Values
    // const attachToBeginMsg = ['nothing', 'name']
    const newInquiriesVisibleTo = ['all', 'Admin']
    const botActiveOpt = [true, false]
    const leadMailSupportedOpt = [true, false]
    const circularAssociateInquiriesWithAgentArray = [true, false]
    const isClosedRemarksSupportedArray = [true, false]
    const mailSignatureSupportedArray = [true, false]
    const enableAutoMsgSaveArray = [true, false]
    // const booleanSelectionTypeOpt = [true, false]
    // const openOnInquirieType = ['1','2']

    const handleOnActiveStartDayChange = useCallback((event) => {
        const newValue = replaceAll(event.target.value, /[^\d]/, '');
        if ((newValue.length === 1 && parseInt(newValue) > 0 && parseInt(newValue) < 8) || newValue.length === 0) {
            setActiveStartDay(newValue);
            setSettingsMiddleware('bot', 'activeStartDay', newValue);
        }
    }, [setSettingsMiddleware]);

    const handleOnActiveEndDayChange = useCallback((event) => {
        const newValue = replaceAll(event.target.value, /[^\d]/, '');
        if ((newValue.length === 1 && parseInt(newValue) > 0 && parseInt(newValue) < 8) || newValue.length === 0) {
            setActiveEndDay(newValue);
            setSettingsMiddleware('bot', 'activeEndDay', newValue);
        }
    }, [setSettingsMiddleware]);

    const handleStartTimeChange = (data) => {
        setActiveStartTime(data);
        setSettingsMiddleware('bot', 'activeStartTime', data);
    };

    const handleEndTimeChange = (data) => {
        setActiveEndTime(data);
        setSettingsMiddleware('bot', 'activeEndTime', data);
    };

    return (
        <section className={styles.channelSettingsSection}>
            <div className={styles.inquiries}>
                <h2 className={styles.settingsTitle}>{t('Messages')} :</h2>
                <SettingsTextBox className={styles['attach-to-begin-Msg-input-container']} type='textarea' nowValue={channelSettings.attachToBeginMsg} id='attachToBeginMsg' setSettings={setSettingsMiddleware} settingType={'channel'} settingName={'attachToBeginMsg'} label={'attachToMsg'} detailsLabel='to add name write template parameter {{name}}' />
                {/* <SettingsDropDown nowSelected={channelSettings.attachToBeginMsg} setSettings={setSettingsMiddleware} settingType={'channel'} label={'attachToMsg'} settingName={'attachToBeginMsg'} items={attachToBeginMsg} /> */}

                {/* <h2 className={styles.settingsTitle}>{t('Message on close inquire')}</h2> */}
                <SettingsTextBox className={styles['onCloseInquireAndSurvey']} type='textarea' nowValue={channelSettings.inquirieClosedMsg} id='inquirieClosedMsg' setSettings={setSettingsMiddleware} settingType={'channel'} settingName={'inquirieClosedMsg'} label={'Message on close inquiry'} detailsLabel='to add survey add surveyId' />

                {/* <h2 className={styles.settingsTitle}>{t('Reminders')}</h2> */}
                <SettingsTextBox className={styles['onCloseInquireAndSurvey']} type='textarea' nowValue={channelSettings.inquirieReminderMsg} id='inquirieClosedMsg' setSettings={setSettingsMiddleware} settingType={'channel'} settingName={'inquirieReminderMsg'} label={'Reminder about open inquiry'} detailsLabel='A reminder message to the customer on an open inquiry that is not answered' />

                <h2 className={styles.settingsTitle}>{t('Bot') + ' :'}</h2>
                <SettingsDropDown nowSelected={botSettings.activeBot} setSettings={setSettings} settingType={'bot'} label={'whatsapp'} settingName={'onSetBotActivity'} items={botActiveOpt} />

                <h2 className={styles.settingsTitle}>
                    {t('Bot Active Time') + ' :'}
                    <Button className={styles.btnShowOrHideActiveBotTime} variant="secondary" onClick={() => setShowBotActiveTime(prev => !prev)}>
                        {showBotActiveTime ? t('Hide Bot Active Time') : t('Show Bot Active Time')}
                    </Button>
                </h2>
                {/* <h2 className={styles.settingsTitle}>{t('Bot Active Time') + ' :'}</h2> */}
                {showBotActiveTime && (
                    <div className={styles.manageChatBotTimes}>
                        <div className={styles.flexRow}>
                            <div className={styles.flexContainer}>
                                <label className={styles.autoBotStartLabel}>{t('Start day')}</label>
                                <input type='text' className={styles.dayInput} onChange={handleOnActiveStartDayChange} value={activeStartDay} />
                            </div>
                            <div className={styles.flexContainer}>
                                <label className={styles.autoBotEndLabel}>{t('End day')}</label>
                                <input type='text' className={styles.dayInput} onChange={handleOnActiveEndDayChange} value={activeEndDay} />
                            </div>
                        </div>
                        <div className={styles.flexRow}>
                            <div className={styles.flexContainer}>
                                <label className={styles.autoBotStartLabel}>{t('Hour start')}</label>
                                <Flatpickr options={{ time_24hr: true, enableTime: true, noCalendar: true }} className={styles.flatPickerCostume} value={activeStartTime} onChange={handleStartTimeChange} />
                            </div>
                            <div className={styles.flexContainer}>
                                <label className={styles.autoBotEndLabel}>{t('Hour end')}</label>
                                <Flatpickr options={{ time_24hr: true, enableTime: true, noCalendar: true }} className={styles.flatPickerCostume} value={activeEndTime} onChange={handleEndTimeChange} />
                            </div>
                        </div>
                    </div>
                )}

                <h2 className={styles.settingsTitle}>{t('Leads') + ' :'}</h2>
                <SettingsDropDown nowSelected={channelSettings.isLeadMailSupported} setSettings={setSettingsMiddleware} settingType={'channel'} label={'isLeadMailSupported'} settingName={'isLeadMailSupported'} items={leadMailSupportedOpt} />

                {/* <h2 className={styles.settingsTitle}>{t('Contacts') + ' :'}</h2>
                <SettingsDropDown nowSelected={generalSettings.enableFetchContactFromCrm} setSettings={setSettings} settingType={'general'} label={'Enable fetch contacts from chats and calls'} settingName={'onSetEnableFetchContactFromCrm'} items={booleanSelectionTypeOpt} /> */}

                <h2 className={styles.settingsTitle}>{t('Inquiries')} :</h2>
                <SettingsDropDown nowSelected={channelSettings.newInquiriesVisibleTo} setSettings={setSettingsMiddleware} settingType={'channel'} label={'newInquiriesVisibleTo'} settingName={'newInquiriesVisibleTo'} items={newInquiriesVisibleTo} />
                <SettingsDropDown nowSelected={channelSettings.circularAssociateInquiriesWithAgent} setSettings={setSettingsMiddleware} settingType={'channel'} label={'circularAssociateInquiriesWithAgent'} settingName={'circularAssociateInquiriesWithAgent'} items={circularAssociateInquiriesWithAgentArray} />
                <SettingsDropDown nowSelected={channelSettings.isClosedRemarksSupported} setSettings={setSettingsMiddleware} settingType={'channel'} label={'isClosedRemarksSupported'} settingName={'isClosedRemarksSupported'} items={isClosedRemarksSupportedArray} />
                <h2 className={styles.settingsTitle}>{t('Email')}</h2>
                <SettingsDropDown nowSelected={channelSettings.emailSignature.enabled} setSettings={setSettingsMiddleware} settingType={'channel'} label={'emailSignature.enabled'} settingName={'emailSignature.enabled'} items={mailSignatureSupportedArray} />

                <div className={styles['settings-row']}>
                    <label htmlFor="maxInquiries">{t('Max in process inquiries')}</label>
                    <input className={styles['text-input']} onChange={(e) => setSettingsMiddleware('channel', 'maxInProcessInquiries', e.target.value)} value={channelSettings.maxInProcessInquiries} id="maxInquiries" type='number' />
                </div>
                <div className={styles['settings-row']}>
                    <label htmlFor="closeInquiriesAfterHours">{t('auto close inquiry after (hours)')}</label>
                    <input className={styles['text-input']} onChange={(e) => setSettingsMiddleware('channel', 'closeInquiriesAfterHours', e.target.value)} value={channelSettings.closeInquiriesAfterHours} id="closeInquiriesAfterHours" type='number' />
                </div>

                <div className={styles['settings-row']}>
                    <label htmlFor="sendMsgToOpenInqNoResFromClientAfterHours">{t('Send Msg To Open Inquire No Response From Client After Hours')}</label>
                    <input className={styles['text-input']} onChange={(e) => setSettingsMiddleware('channel', 'sendMsgToOpenInqNoResFromClientAfterHours', e.target.value)} value={channelSettings.sendMsgToOpenInqNoResFromClientAfterHours} id="sendMsgToOpenInqNoResFromClientAfterHours" type='number' />
                </div>

                <h2 className={styles.settingsTitle}>{t('Management of scheduled message sending')} :</h2>
                <SettingsDropDown nowSelected={channelSettings.enableAutoMsgSave} setSettings={setSettingsMiddleware} settingType={'channel'} label={'enableAutoMsgSave'} settingName={'enableAutoMsgSave'} items={enableAutoMsgSaveArray} />
                <div className={styles.someSettingDiv}>
                    <span className={styles.specificSettingsText}>{t('Select a scheduled message')}: </span>
                    <DropdownButton className={styles.specificSettingsDropDown} variant='secondary' title={!selectedTempMsgState ? t('Create a new message') : selectedTempMsgState.msg.substring(0, 25) + '...'}>
                        {
                            allTempMsgAtt
                        }
                    </DropdownButton>
                </div>

                <section className={styles.tempMsgTextAreaManagementPanelSection}>
                    <h2 className={styles.settingsTitle}>{t('Template Managment')}</h2>
                    <textarea value={nowSelectedMsgTextState} onChange={(event) => setNowSelectedMsgTextState(event.target.value)} className={styles.tempMsgTextArea} />
                    <span className={styles.specificSettingsLabel} >{t('Display Msg')} </span>
                    <DropdownButton className={styles.costDropDownBtn} variant='secondary' title={displaySelectedTempMsgState ? t('true') : t('false')}>
                        <Dropdown.Item key={'displayMsgYes'} onClick={() => setDisplaySelectedTempMsgState(true)} className={styles.costDropDownListItem}>{t('yes')}</Dropdown.Item>
                        <Dropdown.Item key={'displayMsgNo'} onClick={() => setDisplaySelectedTempMsgState(false)} className={styles.costDropDownListItem}>{t('no')}</Dropdown.Item>
                    </DropdownButton>

                    <div className={styles.saveRemoveProjectDiv}>
                        <Button className={styles.updateAutoMsgTimeClicked} variant='success' disabled={nowSelectedMsgTextState.length === 0} onClick={saveTempMsg} >{t('save')}</Button>
                        {
                            selectedTempMsgState &&
                            <Button className={styles.updateAutoMsgTimeClicked} variant='danger' onClick={deleteTempMsg}>{t('remove')}</Button>
                        }
                    </div>
                    {selectedTempMsgState &&
                        <Fragment>
                            <div className={styles.manageTemplateTimes}>
                                <h2 className={styles.settingsTitle}>{t('Auto send message')}</h2>
                                <label className={styles.autoMsgStartLabel}>{t('Hour start')}</label>
                                <Flatpickr options={{ time_24hr: true, enableTime: true, noCalendar: true }} ref={autoMsgStartRef} className={styles.flatPickerCostume} data-enable-time value={autoMsgStartTimePickedState ? autoMsgStartTimePickedState : selectedTempMsgState.autoSendStartTime} onChange={(data) => setAutoMsgStartTimePickedState(data)}></Flatpickr>
                                <label className={styles.autoMsgEndLabel}>{t('Hour end')}</label>
                                <Flatpickr options={{ time_24hr: true, enableTime: true, noCalendar: true }} ref={autoMsgEndRef} className={styles.flatPickerCostume} data-enable-time value={autoMsgEndTimePickedState ? autoMsgEndTimePickedState : selectedTempMsgState.autoSendEndTime} onChange={(data) => setAutoMsgEndTimePickedState(data)}></Flatpickr>
                            </div>
                            <div className={styles.manageTemplateTimes}>
                                <label className={styles.autoMsgStartLabel}>{t('Start day')}</label>
                                <input type='text' className={styles.dayInput} onChange={handleOnStartDayInputChange} value={startDayInputState} />
                                <label className={styles.autoMsgEndLabel}>{t('End day')}</label>
                                <input type='text' className={styles.dayInput} onChange={handleOnEndDayInputChange} value={endDayInputState} />
                                <Button className={styles.updateAutoMsgTimeClicked} disabled={!autoMsgStartTimePickedState || !autoMsgEndTimePickedState || !startDayInputState || !endDayInputState} variant='success' onClick={() => onAcceptNotifyClicked()}>{t('Update')}</Button>
                                <Button className={styles.updateAutoMsgTimeClicked} variant='danger' onClick={() => onCancelNotifyClicked(selectedTempMsgState)}>{t('Cancel')}</Button>
                            </div>
                        </Fragment>
                    }
                </section>

            </div>
        </section >
    )
}

export default ChannelSettings
